module.exports = __webpack_public_path__ + "static/img/wisnia.fcec4e5d.webp";